<template>
  <m-base
    :showTopBorder="pattern.showTopBorder"
    :showRightBorder="pattern.showRightBorder"
    :showBottomBorder="pattern.showBottomBorder"
    :showLeftBorder="pattern.showLeftBorder"
    :showHeader="false"
    :showPadding="false"
    :showLeftPadding="pattern.showLeftPadding"
    :showRightPadding="pattern.showRightPadding"
    :showTopPadding="pattern.showTopPadding"
    :showBottomPadding="pattern.showBottomPadding"
    :showBorderRadius="pattern.showBorderRadius"
    :boxType="pattern.boxType"
    :backgroundColor="pattern.backgroundColor"
  >
    <div
      slot="content"
      :class="{'img-radius':pattern.showImgBorderRadius}"
      @click="navToDetailPage"
    >
      <!-- 标题栏和状态栏占位符 -->
      <van-image lazy-load width="100%" :src="data.src" />
    </div>
  </m-base>
</template>

<script>
export default {
  props: {
    params: {
      type: Object,
      default: () => { }
    },
    data: {
      type: Object,
      default: () => {
        return {
          src: '',
          navTo: ''
        }
      }
    },
    pattern: {
      type: Object,
      default: () => {
        return {
          showTopBorder: false,
          showRightBorder: false,
          showBottomBorder: true,
          showLeftBorder: false,
          showBorderRadius: false,
          showLeftPadding: true,
          showRightPadding: true,
          showTopPadding: true,
          showBottomPadding: true,
          showImgBorderRadius: false,
          boxType: 'block',
          backgroundColor: 'rgba(255,255,255,1)',
        }
      }
    },
  },
  data () {
    return {

    };
  },
  methods: {
    navToDetailPage () {
      let navTo = this.data.navTo
      if (navTo) {
        if (navTo.indexOf('http') > -1) {
          window.location.href = navTo
        } else {
          this.$router.push(this.$uitl.getPathQuery(navTo))
        }
      }
    },
  }
}
</script>

<style lang="scss" scoped>
img {
  display: block;
  width: 100%;
}
.img-radius {
  border-radius: 12px;
  overflow: hidden;
}
</style>
